export default {
  POST_PAGE_VIEW: "/api/v1/page-view",
};
